export default __webpack_public_path__ + "static/media/painscale_info.d73b1185.png";